import httpService from "V2.0/services/httpService";

export {
  GetPipelineV2RunsRequest,
  DeletePipelineV2RunRequest,
  GetPipelineV2RunsPaginatedRequest,
  getPipelineV2Runs,
  deletePipelineV2Run,
  getPipelineV2RunsPaginated,
};

const routes = {
  getPipelineV2Runs: "/pipelineRunsv2/whitelabelGetPipelineRuns",
  deletePipelineV2Run: "/pipelineRunsV2/whitelabelDeletePipelineRun",
  getPipelineV2RunsPaginated: "/pipelineRunsV2/whitelabelGetPipelineRunsPaginated",
} as const;

interface GetPipelineV2RunsRequest {
  params: { workspaceId: string };
  query?: {
    pipelineId: string;
  };
}

function getPipelineV2Runs(request: GetPipelineV2RunsRequest) {
  const { params, query = {} } = request;

  return httpService.get(`${routes.getPipelineV2Runs}/${params.workspaceId}`, {
    params: query,
  });
}

interface GetPipelineV2RunsPaginatedRequest {
  params: {
    workspaceId: string;
  };
  query: {
    pipelineId: string;
    page: number;
    pageSize: number;
    status?: string;
    contactId?: string;
  };
}

function getPipelineV2RunsPaginated(
  request: GetPipelineV2RunsPaginatedRequest,
) {
  const { params, query } = request;

  return httpService.get(
    `${routes.getPipelineV2RunsPaginated}/${params.workspaceId}`,
    {
      params: query,
    },
  );
}

interface DeletePipelineV2RunRequest {
  params: {
    workspaceId: string;
    pipelineRunId: string;
  };
}

function deletePipelineV2Run(request: DeletePipelineV2RunRequest) {
  const { params } = request;
  return httpService.delete(
    `${routes.deletePipelineV2Run}/${params.workspaceId}/${params.pipelineRunId}`,
  );
}
